<template lang="pug">
.v-page-text.page-text(v-if="data")
	.page-text__head(v-if="data.title")
		component.page-text__head-title(:is="data.titleLevel ? data.titleLevel : 'h1'" :class="data.titleStyleLevel") {{data.title}}
	.page-text__body
		.page-text__left(v-if="data.text")
			.page-text__content(ref="content" :class="{'page-text__content--open' : isOpen}") {{ data.text }}
			.page-text__showmore(v-if="isButtonShow" )
				button.page-text__action.btn.btn--icon.btn--gray.btn--sm(@click="toggleOpen" :class="{'btn--opened' : isOpen}")
					| {{data.showMoreButton || 'Читать все'}}
					v-svg-icon.btn__icon(icon="chevron-down-sm")
		.page-text__right
			.page-text__actions
				template(v-for="(button, index) in data.buttons" :key="index")
					.page-text__action
						component.btn(
							:is="button.href ? 'a' : 'button'"
							:class="button.className"
							@click="button.href ? null : handleClick(button.event)" :href="button.href"
							) {{button.text}}
		transition(name="show-aside")
			.aside-modal(v-if="asideOpen ")
				.aside-modal__overlay(@click.stop="closeForm")
				.aside-modal__inner.scrollbar
					.aside-modal__body
						button.aside-modal__close(@click.stop="closeForm")
							v-svg-icon.aside-modal__close-icon(icon="cross")
						template(v-if="$slots['feedback-form']")
							slot(name="feedback-form")
</template>

<script>
import sourceMixin from '../components/mixins/v-mixin-source.vue';
import isMobMixin from '../components/mixins/v-mixin-is-mob.vue';

export default {
	mixins: [
		sourceMixin,
		isMobMixin
	],
	data() {
		return {
			data: null,
			isOpen: false,
			asideOpen: false,
			isButtonShow: false
		}
	},
	methods: {
		dataSet(data) {
			this.data = data;
			this.$nextTick(() => {
				this.isButtonShow = this.$refs.content.offsetHeight < this.$refs.content.scrollHeight
			})
		},
		handleClick(event) {
			if(event === 'aside-modal') {
				this.asideOpen = true;
			}
		},
		closeForm() {
			this.asideOpen = false;
		},
		toggleOpen() {
			this.isOpen = !this.isOpen;
		}
	}
}
</script>